import React from 'react';
import { Cell, Row } from './SingleBlockRow.styles';
import { getScoreColor } from '../../../../../../../helpers/effectReports/chartCounters';
import { Topic } from '../../../../../../../services/reports';
import { BodyBoldM, BodyRegularS } from '../../../../../../../styles/globals';
import TrendBox from '../../../../../SharedEffectReportComponents/TrendBox/TrendBox';

interface SingleBlockRowProps {
  topic: Topic;
}

const SingleBlockRow: React.FC<SingleBlockRowProps> = ({ topic }) => {
  const { label, average_value, change, historical_value, threshold_values } = topic;
  const isNegative = Number(change) < 0;

  return (
    <>
      <Row
        borderColor={getScoreColor(
          average_value,
          threshold_values.low,
          threshold_values.high,
          threshold_values.medium
        )}
      >
        <Cell>
          <BodyRegularS>{label}</BodyRegularS>
        </Cell>
        <Cell>
          <BodyBoldM>{average_value}</BodyBoldM>
        </Cell>
        {historical_value && <TrendBox change={change} isNegative={isNegative} />}
      </Row>
    </>
  );
};

export default SingleBlockRow;
